export default __webpack_public_path__ + "static/PERFORMANCE LAMINATES-72ab27ac96e6057aa233884ee9fbeef7.webp";